
import httpService from '../_utils/http-service';
import { getHttpConfig } from '../_utils/auth-utils';

import { traceEvent, reportError } from "../_utils/analytics-utils";

export const sendVerificationCode = (countryCode, phoneNumber, callback) => {
    return function (dispatch) {
        httpService.post('/customers/phone/sendVerification',
            {
                countryCode,
                phoneNumber,
                verificationType: 'sms'
            },
            getHttpConfig()
        ).then((res) => {
            if (res.data.statusCode === 200) {
                callback({ success: true });
            } else {
                reportError("sendVerificationCode", {res});
                callback({ success: false, error: res.data.message });
            }
        })
            .catch((err) => {
                reportError("sendVerificationCode", {err});
                callback({ success: false });
            });
    }
}

export const verifyPhone = ({ countryCode, phoneNumber, verificationCode }, callback) => {

    return function (dispatch) {
        countryCode = encodeURI(countryCode);
        let url = `/customers/phone/verify?countryCode=${encodeURIComponent(countryCode)}&phoneNumber=${phoneNumber}&verificationCode=${verificationCode}`
        httpService.get(url)
            .then((res) => {

                if (res.data.statusCode === 200) {
                    callback({ success: true, token: res.data.data.token });
                } else {
                    traceEvent("error", "verifyPhone");
                    callback({ success: false, message: res.data.message });
                }
            })
            .catch((err) => {
                traceEvent("error", "verifyPhone");
                callback({ success: false });
            });
    }
}


